export const SITE = {
  name: "GeoDrafts",
  domain: "geodrafts.com",
  origin: "https://geodrafts.com",
  tagline: "Land Surveying & Geospatial Solutions",
  // Primary business contact email (shown across the site).
  email: "cad@geodrafts.com",
  // USA WhatsApp business line (shown across the site).
  whatsappNumber: "+1 938 307 1829",
  whatsappLink: "https://wa.me/19383071829?text=Hi%20GeoDrafts%2C%20I%27d%20like%20to%20discuss%20a%20survey%20CAD%20drafting%20project.",
  description:
    "GeoDrafts is a technical production partner for land surveying professionals, preparing detailed CAD drawings and organized GIS deliverables from supplied project data.",
};

export const SERVICE_OPTIONS = [
  "Land Survey CAD Drafting",
  "Topographic Survey Drafting",
  "Boundary Survey Drafting",
  "ALTA/NSPS Survey Drafting",
  "As-Built Survey Drafting",
  "Mortgage Location Survey Drafting",
  "Subdivision Plat Drafting",
  "Easement Survey Drafting",
  "Construction Staking Drafting",
  "Utility Survey and Mapping",
  "Route / Right-of-Way Drafting",
  "Drone / Point Cloud Drafting",
  "FEMA Elevation Certificate Drafting",
  "GIS Mapping",
  "GIS Data Conversion",
  "Cadastral Mapping Services",
  "Plot Plan Drafting",
  "Grading and Earthwork Drafting",
  "Road and Highway Survey Drafting",
  "PDF to CAD Conversion",
  "Point Cloud to CAD Conversion",
  "Survey Data Processing",
  "Other Survey/GIS Requirement",
];

export const VOLUME_OPTIONS = [
  "Single project",
  "1-5 projects/month",
  "5-20 projects/month",
  "20+ projects/month",
  "Ongoing partnership",
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Share Project Inputs",
    desc: "The client supplies available survey data, sketches, coordinates, drawings, GIS files, standards, and project instructions.",
  },
  {
    num: "02",
    title: "Confirm Scope",
    desc: "GeoDrafts reviews the requested outputs, file formats, drafting standards, assumptions, and schedule.",
  },
  {
    num: "03",
    title: "Prepare the Deliverables",
    desc: "The assigned CAD drafting or GIS production work is completed according to the agreed scope.",
  },
  {
    num: "04",
    title: "Review and Refine",
    desc: "Deliverables are checked against the supplied instructions and agreed quality-review requirements. Requested revisions are handled according to the project agreement.",
  },
  {
    num: "05",
    title: "Deliver Project Files",
    desc: "Final files are provided in the agreed formats with a clear, organized handover.",
  },
];

export const MARQUEE_ITEMS = [
  "Land Survey CAD Drafting",
  "Topographic Survey Drafting",
  "Boundary & Property Plans",
  "ALTA/NSPS Survey Drafting",
  "As-Built & Existing Conditions",
  "GIS Mapping & Spatial Data",
  "CAD-to-GIS Conversion",
  "DWG · DXF · PDF",
  "SHP · GeoPackage · GeoJSON · KML",
];
